module.exports = __webpack_public_path__ + "img/pafos-logo-icon.cb2af0bc.png";